// SCREEN_TREND (急上昇) で使うAPI

export const getTrendingVideos = async (range = "24h") => {
  const response = await fetch(
    `https://daikou-diverse-api.com/api/data_202608/trend?period=${range}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    throw new Error(`HTTP error: ${response.status}`);
  }

  return await response.json();
};
